import { WORKSPACE_ROUTES } from "@/lib/workspace-routes";
import {
  manifoldExampleReturnTo,
  manifoldExampleSearch,
  type ManifoldExample,
} from "./examples";

const KEY = "abg.manifold.explore.v1";

export function stageManifoldExplore(example: ManifoldExample) {
  const href = `${WORKSPACE_ROUTES.workbenchModel}?${manifoldExampleSearch(example)}`;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ href, at: Date.now() }));
  } catch {
    /* The explicit login return URL still works without storage. */
  }
  return href;
}

export function readManifoldExploreReturnTo() {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) ?? "null");
    if (
      !value ||
      typeof value.at !== "number" ||
      Date.now() - value.at > 86400000 ||
      value.at > Date.now() ||
      typeof value.href !== "string"
    )
      return null;
    return manifoldExampleReturnTo(value.href);
  } catch {
    return null;
  }
}

export function clearManifoldExplore() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Optional continuation. */
  }
}
